import { useBanner } from "../../contexts";
import { BannerGroupsInlineStyles } from "./inlineStyles";

var BannerGroupSectionTitle = function BannerGroupSectionTitle(_ref) {
  var title = _ref.title,
      children = _ref.children;
  var banner = useBanner();
  return h("div", BannerGroupsInlineStyles.title(banner), title, children && h("div", BannerGroupsInlineStyles.description(banner), children));
};

export { BannerGroupSectionTitle };